import { useCallback } from 'react';
import { useToast } from '@practium/ui';

export type ImportResultSummary = {
	created: number;
	totalRows: number;
	updated?: number;
	errors?: {
		row: number;
		message: string;
	}[];
};

const getImportSummaryMessages = (result: ImportResultSummary) => {
	const errors = result.errors ?? [];
	const createdLabel = result.created === 1 ? 'registro criado' : 'registros criados';
	const updatedLabel = result.updated === 1 ? 'registro atualizado' : 'registros atualizados';
	const messages = [`Importação concluída: ${result.created} ${createdLabel} de ${result.totalRows} linhas.`];

	if (typeof result.updated === 'number' && result.updated > 0) {
		messages.push(`${result.updated} ${updatedLabel}.`);
	}

	if (errors.length > 0) {
		messages.push(...errors.map((error) => `Linha ${error.row}: ${error.message}`));
	}

	return messages;
};

export const useImportResultToast = () => {
	const toast = useToast();

	const showImportResultToast = useCallback(
		(result: ImportResultSummary) => {
			const hasErrors = Boolean(result.errors?.length);
			const messages = getImportSummaryMessages(result);

			if (hasErrors && result.created === 0 && !result.updated) {
				messages.forEach((message) => toast.error(message));
				return;
			}

			if (hasErrors) {
				messages.forEach((message) => toast.info(message));
				return;
			}

			messages.forEach((message) => toast.success(message));
		},
		[toast]
	);

	return { showImportResultToast };
};
